import { getAppConfig, msalInstance } from '..';
export async function authedFetch(uri, request = null, parseResult = false) {
    const token = await getAccessToken();
    if (token) {
        request = request ?? { method: 'GET' };
        request.headers = request.headers ?? {};
        request.headers['Authorization'] = `Bearer ${token}`;
    }
    const newRequest = request;
    const response = await fetch(uri, newRequest);
    return parseResult ? handleResponse(response) : response;
}
export async function getAccessToken() {
    const configuration = getAppConfig();
    const account = msalInstance?.getActiveAccount();
    if (!account) {
        return;
    }
    const authResult = await msalInstance
        .acquireTokenSilent({
        scopes: [configuration.REACT_APP_BFF_API_SCOPES],
        account: account,
    })
        .catch(error => {
        // fallback to interaction when silent call fails
        return msalInstance.acquireTokenRedirect({
            scopes: [configuration.REACT_APP_BFF_API_SCOPES],
            account: account,
        });
    });
    return authResult?.accessToken;
}
export async function handleResponse(response) {
    //can't use useToast(), would need to find alternative
    //   const { showErrorToast } = useToast();
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            return undefined;
        }
        return data;
    });
}
